import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useSectors = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'sectors',
    gqlEntityKey: 'sectors',
    queryName: 'GET_SECTORS_QUERY',
    createMutation: 'CREATE_SECTOR_MUTATION',
    updateMutation: 'UPDATE_SECTOR_MUTATION',
    deleteMutation: 'DELETE_SECTOR_MUTATION',
    updateVariableName: 'set',
    transformData: (sector) => ({
      ...sector,
      company_name: sector.company?.name || `Company ${sector.company_id}`,
      sector_name: sector.sector_name,
      sector_description: sector.sector_description,
      sector_status: sector.sector_status ? 'active' : 'inactive',
      companyId: sector.company_id,
    }),
    transformFormData: (formData) => ({
      sector_name: formData.sector_name,
      sector_description: formData.sector_description || null,
      sector_status: formData.sector_status === 'active',
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useSectors }; 